<template>
  <div class="setting props-group">
    <el-form-item class="title" label="设置值">
      <el-switch v-model="component.properties.default.settingEnable"></el-switch>
    </el-form-item>
    <div class="setting-value" v-if="component.properties.default.settingEnable">
      <div class="default-value" v-if="includeComponents.includes(component.componentType)">
      <el-form-item class="title" label="默认值">
        <el-switch v-model="component.properties.default.enable"></el-switch>
      </el-form-item>
      <el-form-item v-if="component.properties.default.enable" label="表达式"
          prop="properties.default.defaultValue"
          :rules="{required: true, message: '请输入公式', trigger: 'blur'}">
            <div class="formula" v-html="defaultExpressShow" @click="focus('default',component.properties.default.defaultValue)"></div>
      </el-form-item>
    </div>

    <div class="related" v-if="includeRelatedComponents.includes(component.componentType)">
      <el-form-item label="关联字段">
        <el-switch v-model="component.properties.related.enable"></el-switch>
      </el-form-item>
      <template v-if="component.properties.related.enable">
        <el-form-item label="关联控件"
            prop="properties.related.relComponent"
            :rules=" { required: true, message: '请输入关联控件', trigger: 'change' }">
          <el-select v-model="component.properties.related.relComponent"
            @change="clearRel"
            clearable filterable>
            <el-option value="currentUserId" label="[登录人信息]"></el-option>
            <el-option v-for="item in relatedAssembly" :key="item.id" :label="item.name" :value="item.id" :disabled="item.id === component.columnId"/>
          </el-select>
        </el-form-item>
        <el-form-item label="来源位置"
            prop="properties.related.srcLocation"
            :rules=" { required: true, message: '请输入来源位置', trigger: 'change' }">
          <public-combobox v-model="component.properties.related.srcLocation" :options="tableOptions" @change="clearField" :disabled="{key: 'setting-value'}"></public-combobox>
        </el-form-item>
        <el-form-item label="关联字段"
            prop="properties.related.relField"
            :rules=" { required: true, message: '请输入关联字段', trigger: 'change' }">
          <public-combobox v-model="component.properties.related.relField" :options="columns"></public-combobox>
        </el-form-item>
        <el-form-item label="来源字段"
            prop="properties.related.srcField"
            :rules=" { required: true, message: '请输入来源字段', trigger: 'change' }">
          <public-combobox v-model="component.properties.related.srcField" :options="columns"></public-combobox>
        </el-form-item>
      </template>
    </div>

    <div class="calculate" v-if="includeCalculateComponents.includes(component.componentType)">
      <el-form-item label="计算">
        <el-switch v-model="component.properties.calculate.enable"></el-switch>
      </el-form-item>
      <el-form-item label="运算公式" v-if="component.properties.calculate.enable"
            prop="properties.calculate.calculationPanelData.expression"
            :rules="{required: true, message: '请输入公式', trigger: 'blur'}">
        <div class="formula" v-html="expressionShow" @click="focus('calc',component.properties.calculate.calculationPanelData.expression)"></div>
      </el-form-item>
      <el-form-item v-if="component.properties.calculate.enable" label-width="80px">
        <template slot="label">
          <span>实时计算</span>&nbsp;
          <el-tooltip content="当勾选此项后每次初始化页面时该计算都将会被执行" placement="bottom-start" class="tooltip">
            <span class="fa fa-exclamation-circle"></span>
          </el-tooltip>
        </template>
        <el-checkbox v-model="component.properties.calculate.realTime"></el-checkbox>
      </el-form-item>
    </div>
    </div>
  </div>
</template>

<script>
import { calculateMixin } from '../components/mixins'
import publicCombobox from '@/components/public/public-combobox.vue'
// 单向管理, 只有在属性内部注册过的控件才能实现该属性
const components = ['rc-input', 'rc-numeric', 'rc-date', 'rc-combobox', 'rc-textarea']
const componentsRelated = ['rc-input', 'rc-numeric', 'rc-date', 'rc-combobox', 'rc-currency', 'rc-textarea', 'rc-id-card']
const componentsCalculate = ['rc-input', 'rc-numeric', 'rc-date', 'rc-combobox', 'rc-currency', 'rc-textarea', 'rc-label']
export default {
  name: 'attr-setting-value',
  mixins: [calculateMixin],
  inject: ['formService'],
  props: ['component', 'options'],
  components: {publicCombobox},
  data () {
    let disabled = !!this.component.properties.default.useComponentId
    return {
      includeComponents: components,
      includeRelatedComponents: componentsRelated,
      includeCalculateComponents: componentsCalculate,
      disabled: disabled,
      schema: this.formService.schema,
      columns: []
    }
  },
  mounted () {
    if (this.component.properties.related) {
      this.initColumns(this.component.properties.related.srcLocation)
    }
  },
  methods: {
    // 关联属性
    initColumns (tabldId) {
      if (tabldId) {
        return this.formService.loadTable(tabldId).then((data) => {
          this.columns = data
        })
      }
    },
    clearRel () {
      this.component.properties.related.srcLocation = ''
      this.component.properties.related.relField = ''
      this.component.properties.related.srcField = ''
    },
    clearField (value) {
      value && this.initColumns(value).then(() => {
        let column = this.columns.find(n => n.columnName === 'Id' || n.columnName === 'id')
        this.component.properties.related.relField = column ? column.id : ''
        this.component.properties.related.srcField = ''
      })
    },

    // 计算

    focus (type, expression) {
      // 改弹窗参照 element this.$message 改造而来, 涉及 ui 方面的可直接参考 element 进行修改
      this.$Popup.calculation({
        parameter: {
          expression: expression,
          dataSource: this.getDataSource,
          currentColumnId: this.component.archive.columnId,
          dataSourceEnable: true,
          dataSourceReports: this.formService.options.dataSourceReports,
          functionType: ['simple', 'math', 'text', 'date', 'logic', 'concat', 'system']
        },
        width: '1000px'
      }).then((data) => {
        // action 两种 confirm 表示点击的是确认, cancel 表示取消
        if (data.action === 'confirm') {
          if (type === 'default') {
            this.getDefaultExpression(data.value)
          } else {
            this.getExpression(data.value)
          }
        }
      })
    },
    getExpression (expression) {
      this.component.properties.calculate.calculationPanelData.expression = expression
    },
    getDefaultExpression (expression) {
      this.component.properties.default.defaultValue = expression
    },
    handlerEnable (val) {
      if (this.component.properties.readonly !== '' || this.component.properties.readonly !== undefined) {
        this.component.properties.readonly = val || this.component.properties.calculate.enable
      }
      if (val) {
        this.component.properties.default.enable = false
        this.component.properties.calculate.enable = false
        this.component.properties.related.enable = false
      }
    }
  },
  watch: {
    'component.properties.default.settingEnable' (val) {
      if (!val) {
        this.component.properties.default.enable = false
        this.component.properties.related.enable = false
        this.component.properties.calculate.enable = false
      }
    },
    'component.properties.default.enable' (val) {
      if (val) {
        this.component.properties.related.enable = false
        this.component.properties.calculate.enable = false
      }
    },
    'component.properties.related.enable' (val) {
      this.handlerEnable(val)
      this.component.properties.related.enable = val
    },
    // 切换控件时关联表不同
    'component.properties.related.srcLocation' (val) {
      this.initColumns(val)
    },
    'component.properties.calculate.enable' (val) {
      if (!val) {
        this.component.properties.calculate.calculationPanelData.expression = ''
      }
      this.handlerEnable(val)
      this.component.properties.calculate.enable = val
    },

    'component.archive.dataType' (val) {
      this.component.properties.default.defaultValue = ''
    }
  },
  computed: {
    getComponents () {
      let components = this.formService.getSameLevelcomponent(this.component)
      return components.filter(m => m.id !== this.component.id)
    },

    relatedAssembly () {
      let components = this.formService.getSameLevelcomponent(this.component)
      return components.filter(m => m.id !== this.component.id)
    },
    tableOptions () {
      return this.formService.options.tables
    },
    expressionShow () {
      if (this.component.properties.calculate.calculationPanelData.expression) {
        return this.expressionToWithCode(this.component.properties.calculate.calculationPanelData.expression)
      }
    },
    defaultExpressShow () {
      if (this.component.properties.default.defaultValue) {
        return this.expressionToWithCode(this.component.properties.default.defaultValue)
      }
    }
  }
}
</script>

<style lang="scss">
 .setting.props-group {
   border-top: 1px solid #c2c3c4;
   margin: 0 -20px;
   padding: 0 20px;

   .setting-value {
     border: 1px solid #c2c3c4;
     padding-left: 10px;
     padding-right: 10px;
     margin-bottom: 14px;
   }

   .default-value {
     .number {
       &.el-input-number {
        width: 105px;
       }
       >div {
         input {
           text-align: left;
         }
       }
     }

     .default-column>div {
       margin-bottom: 15px;
     }
   }

   .calculate,.setting-value {
     margin: 0 -20px;
     padding: 0 20px;

     .formula {
       position: absolute;
       margin-top: -14px;
       padding: 0 10px;
       top: 50%;
       outline: none;
       border: 1px solid #e4e7ed;
       background: #fff;
       border-radius: 4px;
       max-height: 80px;
       overflow: hidden;
       width: 100%;
       height: 28px;
       line-height: 28px;

       code {
         padding: 2px 4px;
         font-size: 90%;
         color: #c7254e;
         background-color: #f9f2f4;
         border-radius: 4px;
       }
     }
   }
 }

</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/setting-value.vue